import { addCtaClickListener } from "lib/tracking/ctaTracking";

addCtaClickListener(document.querySelector("#main"));
